import { Box, Grid, Typography, useTheme } from "@mui/material";
import TeamCarousel from "../components/About/Team";
import Jobs from "../components/Careers/Jobs";
import StayInLoop from "../components/StayInLoop";
import { IndiaFlag, USFlag } from "../constant";
import { address } from "framer-motion/client";
import axios from "axios";
import { useEffect, useState } from "react";

const formatTo12Hour = (time) => {
    if (!time) return "";

    const [hours, minutes] = time?.split(":");
    const hour = parseInt(hours, 10);

    const ampm = hour >= 12 ? "pm" : "am";
    const formattedHour = hour % 12 || 12;

    return `${formattedHour}:${minutes} ${ampm}`;
};

const data = {
    title: "We are always happy to assist you",
    contactDetails: [{
        address: "112 ARV Park, H-28 Sector 63, Noida, India",
        email: " zero@ienergy.ai",
        contactNumber: "",
        workingDays: "Monday - Friday",
        officeTimingFrom: "9am",
        officeTimingTo: "6pm"
    },
    {
        address: "Nuviro LLC, 15605, 100th PL NE, Bothell, WA 98011, USA",
        email: " zero@ienergy.ai",
        contactNumber: "",
        workingDays: "Monday - Friday",
        officeTimingFrom: "9am",
        officeTimingTo: "6pm"
    }]

}


const AddressSection = () => {
    const [data, setData] = useState({
        heading: "",
        locations: [],
    });

    useEffect(() => {
        getAddList();
    }, []);

    const getAddList = async (page = 1, limit = 100) => {
        try {
            const url = `https://dev.ienergydigital.com/task-api/api/cms/entries/?type=office-location&page=${page}&limit=${limit}`;

            const response = await axios.get(url);

            const entry = response.data?.data?.entries?.[0];

            if (!entry?.contentJson) {
                setData({
                    heading: "",
                    locations: [],
                });
                return;
            }

            const { contentJson } = entry;

            // Get all location objects dynamically
            const locations = Object.keys(contentJson)
                .filter((key) => key.startsWith("location"))
                .filter((key) => typeof contentJson[key] === "object")
                .map((key) => ({
                    ...contentJson[key],
                    key,
                }));

            setData({
                heading: contentJson.heading || "",
                locations,
            });
        } catch (error) {
            console.error(error);

            setData({
                heading: "",
                locations: [],
            });
        }
    };

    return (
        <Box
            sx={{
                minHeight: "50vh",
                background: "linear-gradient(90deg, #0066CC 0%, #4B0082 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "32px",
                position: "relative",
                overflow: "hidden",
            }}
        >
            {/* Contact Info Box */}
            <Grid container spacing={2} maxWidth="1250px" margin="auto">
                <Grid item xs={12} sm={6} md={6}>
                    <Box sx={{ padding: { xs: 2, md: 4 } }}>
                        <Typography
                            variant="h3"
                            component="h2"
                            sx={{
                                fontWeight: 700,
                                color: "white",
                                fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
                                lineHeight: { xs: "2.5rem", md: "3.5rem" },
                                mb: 4,
                            }}
                        >
                            {data?.heading}
                        </Typography>
                    </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                    <Grid container >
                        {data?.locations?.map((ele, index) => (
                            <Grid item xs={12} md={6} key={ele.key}>
                                <Box>
                                    <img
                                        src={index === 0 ? IndiaFlag : USFlag}
                                        alt={`Location ${index + 1}`}
                                        style={{
                                            width: "32px",
                                            height: "32px",
                                            objectFit: "contain",
                                        }}
                                    />

                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 0.5,
                                            mt: 2,
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#D1D5DB",
                                                fontSize: "15px",
                                                lineHeight: 1.6,
                                            }}
                                        >
                                            {ele?.address}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: "#D1D5DB",
                                                fontSize: "16px",
                                            }}
                                        >
                                            {ele?.phone}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: "#D1D5DB",
                                                fontSize: "16px",
                                            }}
                                        >
                                            {ele?.email}
                                        </Typography>

                                        <Typography
                                            variant="subtitle1"
                                            sx={{
                                                color: "#D1D5DB",
                                                mt: 2,
                                            }}
                                        >
                                            Assistance hours:
                                        </Typography>

                                        <Typography
                                            variant="body1"
                                            sx={{
                                                color: "#D1D5DB",
                                            }}
                                        >
                                            {ele?.workingDaysFrom} - {ele?.workingDaysTo}
                                        </Typography>

                                        <Typography
                                            variant="body1"
                                            sx={{
                                                color: "#D1D5DB",
                                            }}
                                        >
                                            {`${formatTo12Hour(
                                                ele?.workingHoursFrom
                                            )} to ${formatTo12Hour(
                                                ele?.workingHoursTo
                                            )} ${index === 1 ? "PST" : "IST"
                                                }`}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}

export default AddressSection;


